// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__1X9nI","success":"Alert_success__pvk9G"};